/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import HtmlEditor from 'shared/ui/components/editors/html/HtmlEditor.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

const __vue_script__ = {
    name: 'WarningWallModal',

    components: {
        BaseInput,
        HtmlEditor,
        Toggler
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        config: {
            type: Object,
            required: true
        },

        onSave: {
            type: Function,
            required: true
        }
    },

    data() {
        return {
            currentLang: this.$i18n.locale,
            wallConfig: {
                enabled: this.config.enabled,
                content: this.config.content,
                redirect: this.config.redirect
            }
        };
    },

    methods: {
        async saveConfig() {
            const valid = await this.$refs.form.validate();
            if (valid && typeof this.onSave === 'function') {
                this.onSave(this.wallConfig);
                this.closeModal();
            }
        },

        closeModal() {
            this.$emit('close');
        }
    }

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"warning-wall-modal modal-wrapper",attrs:{"tag":"form","autocomplete":"off"}},[_c('div',{staticClass:"modal-header"},[_c('span',{staticClass:"close",on:{"click":_vm.closeModal}}),_c('h2',[_vm._v(_vm._s(_vm.$t('registration.configuration.warning_wall')))])]),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(_vm.$t('registration.configuration.warning_wall_description')))]),_c('validation-provider',{attrs:{"slim":true,"name":"warningWallEnabled"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('toggler',{attrs:{"name":"warningWallEnabled","on-label":"registration.configuration.warning_wall_enabled","off-label":"registration.configuration.warning_wall_enabled","errors":errors},model:{value:(_vm.wallConfig.enabled),callback:function ($$v) {_vm.$set(_vm.wallConfig, "enabled", $$v)},expression:"wallConfig.enabled"}})]}}])}),(_vm.wallConfig.enabled)?[_c('validation-provider',{attrs:{"slim":true,"name":"text","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('html-editor',{attrs:{"event-id":_vm.event._id,"name":"text","label":_vm.$t('registration.configuration.warning_wall_text'),"links":true,"enable-custom-bstg-links":false,"extras":false,"images":true,"errors":errors,"blockquote":true},model:{value:(_vm.wallConfig.content[_vm.currentLang]),callback:function ($$v) {_vm.$set(_vm.wallConfig.content, _vm.currentLang, $$v)},expression:"wallConfig.content[currentLang]"}})]}}],null,false,1979009291)}),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('registration.configuration.warning_wall_buttons')))]),(_vm.event.is_content_hub)?_c('i18n',{staticClass:"control-hint",attrs:{"path":"registration.configuration.no_i18n.warning_wall_buttons_hint","tag":"div"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('registration.configuration.no_i18n.warning_wall_buttons_hint_accept')))]),_c('strong',[_vm._v(_vm._s(_vm.$t('registration.configuration.no_i18n.warning_wall_buttons_hint_reject')))])]):_c('i18n',{staticClass:"control-hint",attrs:{"path":"registration.configuration.warning_wall_buttons_hint","tag":"div"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('registration.configuration.warning_wall_buttons_hint_section')))]),_c('strong',[_vm._v(_vm._s(_vm.$t('registration.configuration.warning_wall_buttons_hint_accept')))]),_c('strong',[_vm._v(_vm._s(_vm.$t('registration.configuration.warning_wall_buttons_hint_reject')))])])],1),_c('validation-provider',{attrs:{"slim":true,"name":_vm.$t('registration.configuration.warning_wall_redirect').toLowerCase(),"rules":"required|url"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"type":"text","name":"wallRedirect","hint":_vm.$t('registration.configuration.warning_wall_redirect_hint'),"hint-after-label":true,"label":_vm.$t('registration.configuration.warning_wall_redirect'),"placeholder":_vm.$t('registration.configuration.warning_wall_redirect_placeholder'),"errors":errors},model:{value:(_vm.wallConfig.redirect[_vm.currentLang]),callback:function ($$v) {_vm.$set(_vm.wallConfig.redirect, _vm.currentLang, $$v)},expression:"wallConfig.redirect[currentLang]"}})]}}],null,false,1580575746)})]:_vm._e()],2),_c('div',{staticClass:"modal-footer"},[_c('footer',{staticClass:"actions"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.closeModal.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.saveConfig.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "WarningWallModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__